// English is the source language: the fallback, and the shape every key is
// type-checked against (see ./i18next.d.ts). Both languages are bundled; two
// small catalogs are cheaper than a second round trip.
import enArchitecture from "./locales/en/architecture.json";
import enAuth from "./locales/en/auth.json";
import enChangelog from "./locales/en/changelog.json";
import enCommon from "./locales/en/common.json";
import enDocs from "./locales/en/docs.json";
import enDocsApi from "./locales/en/docsApi.json";
import enDocsTools from "./locales/en/docsTools.json";
import enDocuments from "./locales/en/documents.json";
import enErrors from "./locales/en/errors.json";
import enExperiments from "./locales/en/experiments.json";
import enGithub from "./locales/en/github.json";
import enLanding from "./locales/en/landing.json";
import enPortal from "./locales/en/portal.json";
import enPublic from "./locales/en/public.json";
import enRatings from "./locales/en/ratings.json";
import enRoadmap from "./locales/en/roadmap.json";
import enSettings from "./locales/en/settings.json";
import enShell from "./locales/en/shell.json";
import enSlack from "./locales/en/slack.json";
import enTickets from "./locales/en/tickets.json";
import enInbox from "./locales/en/inbox.json";
import enIssues from "./locales/en/issues.json";
import enTicketDetail from "./locales/en/ticketDetail.json";
import enTicketList from "./locales/en/ticketList.json";
import enTriage from "./locales/en/triage.json";
import enWork from "./locales/en/work.json";
import enCycles from "./locales/en/cycles.json";
import enStats from "./locales/en/stats.json";
import enUpdates from "./locales/en/updates.json";
import frArchitecture from "./locales/fr/architecture.json";
import frAuth from "./locales/fr/auth.json";
import frChangelog from "./locales/fr/changelog.json";
import frCommon from "./locales/fr/common.json";
import frDocs from "./locales/fr/docs.json";
import frDocsApi from "./locales/fr/docsApi.json";
import frDocsTools from "./locales/fr/docsTools.json";
import frDocuments from "./locales/fr/documents.json";
import frErrors from "./locales/fr/errors.json";
import frExperiments from "./locales/fr/experiments.json";
import frGithub from "./locales/fr/github.json";
import frLanding from "./locales/fr/landing.json";
import frPortal from "./locales/fr/portal.json";
import frPublic from "./locales/fr/public.json";
import frRatings from "./locales/fr/ratings.json";
import frRoadmap from "./locales/fr/roadmap.json";
import frSettings from "./locales/fr/settings.json";
import frShell from "./locales/fr/shell.json";
import frSlack from "./locales/fr/slack.json";
import frTickets from "./locales/fr/tickets.json";
import frInbox from "./locales/fr/inbox.json";
import frIssues from "./locales/fr/issues.json";
import frTicketDetail from "./locales/fr/ticketDetail.json";
import frTicketList from "./locales/fr/ticketList.json";
import frTriage from "./locales/fr/triage.json";
import frWork from "./locales/fr/work.json";
import frCycles from "./locales/fr/cycles.json";
import frStats from "./locales/fr/stats.json";
import frUpdates from "./locales/fr/updates.json";

export const defaultNS = "common";

export const enResources = {
  common: enCommon,
  auth: enAuth,
  errors: enErrors,
  landing: enLanding,
  docs: enDocs,
  // The body of the Ratings and Experiments pages of /docs, apart from
  // `docs`: past a size, the keys of one namespace are more than Trans's
  // types can spell out.
  docsApi: enDocsApi,
  // What each tool an agent is offered does, on the Agents page: one line per
  // tool of convex/lib/agentTools.ts, and apart from `docs` for the same
  // reason.
  docsTools: enDocsTools,
  public: enPublic,
  portal: enPortal,
  settings: enSettings,
  shell: enShell,
  tickets: enTickets,
  triage: enTriage,
  ticketList: enTicketList,
  ticketDetail: enTicketDetail,
  inbox: enInbox,
  issues: enIssues,
  github: enGithub,
  slack: enSlack,
  architecture: enArchitecture,
  changelog: enChangelog,
  experiments: enExperiments,
  ratings: enRatings,
  roadmap: enRoadmap,
  work: enWork,
  cycles: enCycles,
  stats: enStats,
  updates: enUpdates,
  documents: enDocuments,
} as const;

export const resources = {
  en: enResources,
  fr: {
    common: frCommon,
    auth: frAuth,
    errors: frErrors,
    landing: frLanding,
    docs: frDocs,
    docsApi: frDocsApi,
    docsTools: frDocsTools,
    public: frPublic,
    portal: frPortal,
    settings: frSettings,
    shell: frShell,
    tickets: frTickets,
    triage: frTriage,
    ticketList: frTicketList,
    ticketDetail: frTicketDetail,
    inbox: frInbox,
    issues: frIssues,
    github: frGithub,
    slack: frSlack,
    architecture: frArchitecture,
    changelog: frChangelog,
    experiments: frExperiments,
    ratings: frRatings,
    roadmap: frRoadmap,
    work: frWork,
    cycles: frCycles,
    stats: frStats,
    updates: frUpdates,
    documents: frDocuments,
  },
} as const;

export type Namespace = keyof typeof enResources;
export const NAMESPACES = Object.keys(enResources) as Namespace[];
